import React, { Component } from 'react';
import Database from '../../../../../Helpers/Database.js'
import './styles.scss'

const db = new Database;

class Favorite extends Component {
    constructor(props) {
        super(props);
        this.state = {
            propertyId: '',
            isFavorite: false
        };
    }

    componentDidMount = () => {
        let isFavorite = false;
        if (this.props.favorites && this.props.favorites.includes(this.props.propertyId)) {
            isFavorite = true;
        }

        this.setState({
            propertyId: this.props.propertyId,
            isFavorite
        })
    }

    componentWillReceiveProps = (nextProps) => {
        let isFavorite = nextProps.favorites.includes(nextProps.propertyId)
        this.setState({
            propertyId: nextProps.propertyId,
            isFavorite
        })
        return false;
    }

    handleFavorite = (e) => {
        e.stopPropagation();

        let { propertyId, isFavorite } = this.state;

        db.ajaxCall({
            action: 'favorite_property',
            property_id: propertyId,
        })
            .then((res) => {
                if (res === 'prompt_login') {
                    $('#login-modal').addClass('redirected');
                    $('#login-modal').fadeIn();
                } else {
                    $('#favorites-count span').text(res.favorites_count)
                    this.setState({ isFavorite: !isFavorite })
                    this.props.refreshUser()
                }
            })
    }

    render() {
        let { isFavorite, propertyId } = this.state;
        return (
            <div onClick={this.handleFavorite} className="favorite-container">
                {
                    !isFavorite &&
                    <img src="/wp-content/themes/hayden/assets/images/icons/Listings-Star.svg" alt="default" width="30" height="28" />
                }
                {
                    isFavorite &&
                    <img src="/wp-content/themes/hayden/assets/images/icons/Listings-Star-Active.svg" alt="active" width="30" height="28" />
                }
            </div>
        )
    }
}

export default Favorite;